import { configureStore } from '@reduxjs/toolkit'
import { authReducer } from '../auth/slices/auth.slice'
import { pageReducer } from '../pages/slices/page.slice'
import { facilityReducer } from '../pages/slices/facility.slice'
import { hl7LogReducer } from '../pages/slices/hl7Log.slice'
import { dicomLogReducer } from '../pages/slices/dicomLog.slice'

const store = configureStore({
  reducer: {
    /**
     * Add Reducers here
     */
    auth: authReducer, //Don't remove if you are using GoogleAuth component
    page: pageReducer,
    facility: facilityReducer,
    hl7Log: hl7LogReducer,
    dicomLog: dicomLogReducer,
  },
  // disabling redux dev tools on production
  devTools: process.env.NODE_ENV === 'production' ? false : true,
})

export default store
